import { render, staticRenderFns } from "./KubernetesResource.vue?vue&type=template&id=db1770ac&scoped=true&"
import script from "./KubernetesResource.vue?vue&type=script&lang=js&"
export * from "./KubernetesResource.vue?vue&type=script&lang=js&"
import style0 from "./KubernetesResource.vue?vue&type=style&index=0&id=db1770ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1770ac",
  null
  
)

export default component.exports